import React from "react";
import FormInputToggleButton from "customization/ui/FormInputToggleButton/FormInputToggleButton";
import { useValidity } from "customization/templates/FieldTemplate/FieldTemplate";

const ToggleButtonWidget = ({
  options,
  value,
  required,
  disabled,
  rawErrors,
  readonly,
  autofocus,
  onBlur,
  onFocus,
  onChange,
  id,
  name,
  ...props
}) => {
  // const name = Math.random().toString();
  const { enumOptions, enumDisabled } = options;
  const { isInvalid, handleOnBlur } = useValidity();

  return (
    <div id={id}>
      {enumOptions.map((option, i) => {
        const checked = option.value === value;
        const itemDisabled =
          // eslint-disable-next-line
          enumDisabled && enumDisabled.indexOf(option.value) != -1;

        return (
          <FormInputToggleButton
            key={option.value}
            id={`${id}_${option.label}`}
            name={name}
            invalid={isInvalid}
            checked={checked}
            disabled={disabled || itemDisabled || readonly}
            autoFocus={autofocus && i === 0}
            label={option.label}
            required={required}
            value={option.value}
            onChange={() => {
              onChange(option.value);
            }}
            onBlur={
              onBlur &&
              ((event) => {
                handleOnBlur();
                onBlur(id, event.target.value);
              })
            }
            onFocus={onFocus && ((event) => onFocus(id, event.target.value))}
          />
        );
      })}
    </div>
  );
};

ToggleButtonWidget.defaultProps = {
  autofocus: false,
};

export default ToggleButtonWidget;
